import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PaginationType } from '@typings/requestPayloads'

export interface IListQueryPaginationPayload {
    pagination?: PaginationType
    query?: any
}

export interface selectedCategoryPayload {
    pagination?: PaginationType
    query?: any
}

const initialState = {
    status: STATUS.IDLE,
    data: [],
    mainCategories: null,
    selectedMainCategory: null,
    searchValue: '',
    selectedCategories: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listSlice = createSlice({
    name: 'hub/categoriesSource/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            if (action.payload?.gettingMainCategories) {
                state.mainCategories = action.payload.data
            } else {
                state.data = action.payload.data
                state.pagination = {
                    ...state.pagination,
                    skip: action.payload.skip,
                    total: action.payload.total
                }
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onProductRequest(state, action: PayloadAction<IListQueryPaginationPayload>) {
            state.status = STATUS.RUNNING
        },
        onProductFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        setSelected(state, action) {
            state.selectedCategories = [...action.payload]
        },
        onChangeItem(state, action) {
            for (const key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    }
})

export const listActions = listSlice.actions
export default listSlice.reducer
